import css from 'styled-jsx/css';
import { colors, fonts } from '../common/Theme';

const titleImageWidth = 120;
const titleImageMargin = 12;
const titleImageShiftOffset = 50;
const titleTextMargin = 24;
const componentStyles = css`
  .information {
    position: relative;
    background-color: white;
    padding-top: 24px;
    padding-bottom: 12px;
    min-height: 150px;
  }
  .information:before {
    content: '';
    position: absolute;
    left: -${titleImageShiftOffset}px;
    background: url('/static/images/icons/hey.svg') no-repeat center;
    height: 100%;
    width: ${titleImageWidth}px;
  }

  .title {
    color: ${colors.ywgNavy};
    font-family: ${fonts.primaryFont};
    margin: 12px 0 12px;
  }
  .description {
    font-size: 1.2rem;
    line-height: 1.5;
  }

  .title,
  .description {
    margin-left: ${titleImageWidth - titleImageShiftOffset + titleTextMargin}px;
  }

  .description-emphasis {
    color: ${colors.ywgPinkishOrange};
    font-weight: bold;
  }

  @media (min-width: 600px) {
    .information:before {
      margin-left: ${titleImageMargin}px;
      left: 0;
      background-position: top;
    }
    .title,
    .description {
      margin: 24px 0 24px
        ${titleImageWidth + titleTextMargin + titleImageMargin}px;
    }
  }
`;

const Information = () => (
  <div className="information">
    <h1 className="title">Formulaire de souscription</h1>
    <p className="description">
      Souscrivez à l‘assurance Yupwego en seulement
      <span className="description-emphasis"> 2 minutes !</span>
    </p>

    <style jsx>{componentStyles}</style>
  </div>
);

export default Information;
